import { get, del, post, put } from '../../../../GlobalModules/Utility/Http'
import {
  getQuotations,
  deleteQuotation,
  createQuotation,
  updateQuotation
} from '../Model/QuotationModel'

export const getQuotationsApi = async (filters = {}) => {
  try {
    let queryParams = {}

    const filtersObj = {
      limit: filters.limit || 10,
      offset: filters.offset || 0,
      store_id: localStorage.getItem('store_id')
    }

    if (filters.sort && filters.sort.length > 0) {
      filtersObj.sort = filters.sort.map((item) => ({
        field: item.field,
        sort: item.sort || 'asc'
      }))
    } else {
      // Default to newest first
      filtersObj.sort = [
        {
          field: 'quotation_number',
          sort: 'desc'
        }
      ]
    }

    if (filters.search && filters.search !== '') {
      queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
      filtersObj.search_attr = filters.search
    }

    if (filters.from_created_date) {
      filtersObj.from_created_date = filters.from_created_date
    }
    if (filters.to_created_date) {
      filtersObj.to_created_date = filters.to_created_date
    }

    queryParams.filters = JSON.stringify(filtersObj)

    const response = await get(
      `${process.env.EXTENDED_URL}quotation`,
      queryParams
    )
    return getQuotations(response)
  } catch (error) {
    throw error
  }
}

export const deleteQuotationApi = async (slack) => {
  const response = await del(`${process.env.EXTENDED_URL}quotation/${slack}`)
  return deleteQuotation(response)
}

export const createQuotationApi = async (data) => {
  const response = await post(`${process.env.EXTENDED_URL}quotation`, data)
  return createQuotation(response)
}

export const updateQuotationApi = async (slack, data) => {
  const response = await put(
    `${process.env.EXTENDED_URL}quotation/${slack}`,
    data
  )
  return updateQuotation(response)
}

export const loadBillToListApi = async (keywords = '', type = 'SUPPLIER') => {
  try {
    const normalizedType = String(type || 'SUPPLIER').toUpperCase()
    const trimmed = String(keywords || '').trim()
    if (!normalizedType) {
      return []
    }
    // API doesn't allow empty keywords, so use a single space if empty
    const body = {
      keywords: trimmed || ' ',
      type: normalizedType,
      store_id: localStorage.getItem('store_id')
    }
    const response = await post(
      `${process.env.EXTENDED_URL}common/load_bill_to_list`,
      body
    )
    return response?.data?.data || []
  } catch (err) {
    return []
  }
}

export const loadProductsForQuotationApi = async (keywords, billToSlack) => {
  const trimmed = String(keywords || '').trim()

  // API doesn't allow empty keywords, so use a single space if empty
  const body = {
    keywords: trimmed || ' ',
    // supplier: billToSlack,
    store_id: localStorage.getItem('store_id')
  }
  const response = await post(
    `${process.env.EXTENDED_URL}common/load_product_for_po`,
    body
  )
  const data =
    response?.data?.data || (Array.isArray(response?.data) ? response.data : [])
  return Array.isArray(data) ? data : []
}

export const getQuotationApi = async (slack) => {
  const response = await get(`${process.env.EXTENDED_URL}quotation/${slack}`)
  return response?.data || { success: false, data: null }
}

export const exportQuotationsApi = async (data = {}) => {
  try {
    const requestBody = {
      from_created_date:
        data.from_created_date ||
        new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
          .toISOString()
          .split('T')[0],
      to_created_date:
        data.to_created_date || new Date().toISOString().split('T')[0]
    }
    if (data.status != null && data.status !== '') {
      requestBody.status = data.status
    }
    requestBody.store_id = localStorage.getItem('store_id')
    requestBody.download = 'xlsx'

    let queryParams = {};
    queryParams.filters = JSON.stringify(requestBody);

    // Attempt export (backend may return link or raw bytes or base64 data URL)
    const response = await get(
      `${process.env.EXTENDED_URL}report/quotation`,
      queryParams
    )

    // If API returns a link in JSON
    if (response?.data?.success && response?.data?.link) {
      if (String(response.data.link).startsWith('data:')) {
        const base64Data = response.data.link.split(',')[1]
        const binaryData = atob(base64Data)
        const bytes = new Uint8Array(binaryData.length)
        for (let i = 0; i < binaryData.length; i++)
          bytes[i] = binaryData.charCodeAt(i)
        return {
          success: true,
          data: bytes.buffer,
          message: 'Export completed - converted from base64',
          filename: response.data.filename || 'quotations_export.xlsx'
        }
      }
      return {
        success: true,
        data: response.data.link,
        message: 'Export completed - file URL provided',
        isFileUrl: true,
        filename: response.data.filename || 'quotations_export.xlsx'
      }
    }

    // Otherwise return raw data for caller to blob-ify
    return {
      success: true,
      data: response.data,
      message: 'Export completed'
    }
  } catch (error) {
    console.error('Error exporting quotations:', error)
    throw error
  }
}

export const updateQuotationStatusApi = async (slack, status) => {
  try {
    const response = await put(
      `${process.env.EXTENDED_URL}quotation/status/${slack}`,
      { status }
    )
    return (
      response?.data || { success: false, message: 'Failed to update status' }
    )
  } catch (error) {
    return (
      error?.response?.data || {
        success: false,
        message: 'Failed to update status'
      }
    )
  }
}
